import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Modalite, ModalitesService } from 'src/app/core/modalites.service';
import { AlertesService } from 'src/app/shared/alertes.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-personnes-recues',
  templateUrl: './personnes-recues.component.html',
  styleUrls: ['./personnes-recues.component.css']
})
export class PersonnesRecuesComponent implements OnInit, OnDestroy {
  @Input()
  erreursMap: Map<string, string>;

  public infobulleTotaux: string = 'Le bouton "Calcul Totaux" constitue un outil d\'aide à la saisie. \
    Attention à ne pas l\'utiliser si vous saisissez directement un total sans saisir toutes les valeurs détails,\
    sinon le total que vous avez saisi sera écrasé par le recalcul déclenché par le clic sur le bouton de calcul...';
    
  private subFormulaire: Subscription;

  public rootForm: UntypedFormGroup;
  private subJuridictions: Subscription;
  private subDetailPersonnesRecues: Subscription;
  public nbJuridictions: number = 0;
  private modalites: Modalite[] = [];
  private subscriptions: Subscription[] = [];
  private subTab: Subscription[] = [];
  private subTab2: Subscription[] = [];
  private subCcVifVict: Subscription;
  public ccVifVict_AZero: boolean = false;

  private valeurTableauC31a_1: number[] = [];
  private valeurTableauC31a_2: number[] = [];
  private valeurTableauC31a_3: number[] = [];
  private valeurTableauC31a_4: number[] = [];

  private valeurTableauC31b_1: number[] = [];
  private valeurTableauC31b_2: number[] = [];
  private valeurTableauC31b_3: number[] = [];
  private valeurTableauC31b_4: number[] = [];

  private valeurTableauC31c_1: number[] = [];
  private valeurTableauC31c_2: number[] = [];
  private valeurTableauC31c_3: number[] = [];

  private valeurTableauC31d_1: number[] = [];
  private valeurTableauC31d_2: number[] = [];
  private valeurTableauC31d_3: number[] = [];
    
  private valeurTableauC32_1: number[] = [];
  private valeurTableauC32_2: number[] = [];
  private valeurTableauC32_3: number[] = [];
    
  constructor(
    private formulaireService: FormulaireService,
    public alertesService: AlertesService,
    public modeRendu: ModeRenduService,
    public modaliteService: ModalitesService,
    public saisieService: SaisieService,
    public filtreService: FiltreService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.juridictions) {
      (this.rootForm.get('dg') as UntypedFormGroup).setControl('juridictions', new UntypedFormArray([]));
    } 
    if (! this.detailPersonnesRecues) {
      (this.rootForm.get('personnesRecues') as UntypedFormGroup).setControl('detailPersonnesRecues', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    // on récupère la nomenclature ielst pour trouver le libelle juridiction car on a que ielst 
    this.subscriptions.push(
      this.modaliteService.getModalites('ielstTjTprx').subscribe(modalites => {
        this.modalites = modalites;
      })
    );

    setTimeout(() => {
        // On maj la boucle detailPersonnesRecues avec celle de Dg juridictions
        this.subJuridictions = this.juridictions.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
            if (valeur instanceof Array) {

              if (this.subTab.length !== 0){
                this.subTab.forEach(element => element.unsubscribe());
              }
              this.valeurTableauC31a_1 = [];
              this.valeurTableauC31a_2 = [];
              this.valeurTableauC31a_3 = [];
              this.valeurTableauC31a_4 = [];

              this.valeurTableauC31b_1 = [];
              this.valeurTableauC31b_2 = [];
              this.valeurTableauC31b_3 = [];
              this.valeurTableauC31b_4 = [];

              this.valeurTableauC31c_1 = [];
              this.valeurTableauC31c_2 = [];
              this.valeurTableauC31c_3 = [];

              this.valeurTableauC31d_1 = [];
              this.valeurTableauC31d_2 = [];
              this.valeurTableauC31d_3 = [];

              this.valeurTableauC32_1 = [];
              this.valeurTableauC32_2 = [];
              this.valeurTableauC32_3 = [];
              
              valeur.forEach((juridictions, index) => {
                // Maj de this.detailPersonnesRecues
                this.detailPersonnesRecues.controls[index].get('ccTjRang').setValue(juridictions.xxTjRang);
                this.detailPersonnesRecues.controls[index].get('ccTjIelst').setValue(juridictions.xxTjIelst);

                //Calcul totaux auto C3.1b
                this.calculAutoTotauxC3(index, this.valeurTableauC31a_1, 'ccTjVifTgdNb', 'ccVifTgdNbTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31a_2, 'ccTjVifTgdSuivi', 'ccVifTgdSuiviTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31a_3, 'ccTjVifTgdEntret', 'ccVifTgdEntretTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31a_4, 'ccTjVifTgdNbUrge', 'ccVifTgdNbUrgeTot');      

                //Calcul totaux auto C3.1c
                this.calculAutoTotauxC3(index, this.valeurTableauC31b_1, 'ccTjVifBarNb', 'ccVifBarNbTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31b_2, 'ccTjVifBarSuivi', 'ccVifBarSuiviTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31b_3, 'ccTjVifBarEntret', 'ccVifBarEntretTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31b_4, 'ccTjVifBarNbUrge', 'ccVifBarNbUrgeTot');      

                //Calcul totaux auto C3.1d
                this.calculAutoTotauxC3(index, this.valeurTableauC31c_1, 'ccTjVifEvviCpleSais', 'ccVifEvviCpleSaisTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31c_2, 'ccTjVifEvviCpleVict', 'ccVifEvviCpleVictTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31c_3, 'ccTjVifEvviCpleEntret', 'ccVifEvviCpleEntretTot');      

                //Calcul totaux auto C3.1e
                this.calculAutoTotauxC3(index, this.valeurTableauC31d_1, 'ccTjVifEvviHcpleSais', 'ccVifEvviHcpleSaisTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31d_2, 'ccTjVifEvviHcpleVict', 'ccVifEvviHcpleVictTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC31d_3, 'ccTjVifEvviHcpleEntret', 'ccVifEvviHcpleEntretTot');      

                //Calcul totaux auto C32
                this.calculAutoTotauxC3(index, this.valeurTableauC32_1, 'ccTjEvviHvifSais', 'ccEvviHvifSaisTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC32_2, 'ccTjEvviHvifVict', 'ccEvviHvifVictTot');      
                this.calculAutoTotauxC3(index, this.valeurTableauC32_3, 'ccTjEvviHvifEntret', 'ccEvviHvifEntretTot');      
              });
            }
            this.nbJuridictions = this.formulaireService.getRootForm().get('dg').get('xxTjNb').value;
          });
        this.juridictions.updateValueAndValidity();


        // Mises à jours de la synthèse si une zone bouge sur l'onglet
        this.subFormulaire = this.formulaire.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
          this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.formulaireService.getRootForm().get('bav').get('detailBavs'));
        });
        this.formulaire.updateValueAndValidity();


        // Gestion des controles bloquants en rechargement questionnaire
        for (let index = 0; index < this.detailPersonnesRecues.length; index++) {
          this.saisieService.ajoutValidateurCroisePersonnesRecues(this.detailPersonnesRecues, index);
          this.detailPersonnesRecues.controls[index].updateValueAndValidity();
        }

      // Pour rafraichir les variables possedant des controles croisés inter onglets !!
        // CtrlC17
        this.filtreService.refreshErreur(this.subTab2, 'dg', 'xxRecuVict', 'personnesRecues', 'ccRecuVictNb');
        // CtrlC18
        this.filtreService.refreshErreur(this.subTab2, 'dg', 'xxRecuNvict', 'personnesRecues', 'ccRecuNvictNb');
        // CtrlC19
        this.filtreService.refreshErreur(this.subTab2, 'dg', 'xxRecuTot', 'personnesRecues', 'ccRecuNbTot');
        // CtrlC20
        this.filtreService.refreshErreur(this.subTab2, 'dg', 'xxRecuVict', 'personnesRecues', 'ccVictTot');

    }, 2000);

    // C3.1 - si ccVifVict = 0 alors mettre à 0 : C_TJx_VIF_TGD*, C_TJx_VIF_BAR*, C_TJx_VIF_EVVI_CPLE* et C_TJx_VIF_EVVI_HCPLE*
    this.subCcVifVict = this.formulaire.get('ccVifVict').valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur1 => {
        if (valeur1 === 0) {
            this.detailPersonnesRecues.value.forEach((detailPr, index) => {
              this.detailPersonnesRecues.controls[index].get('ccTjVifTgdNb').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifTgdEntret').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifTgdSuivi').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifTgdNbUrge').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifBarNb').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifBarEntret').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifBarSuivi').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifBarNbUrge').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleSais').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleVict').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleEntret').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleSais').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleVict').setValue(0);
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleEntret').setValue(0);
              this.ccVifVict_AZero = true;
            });  
        } else {
          this.detailPersonnesRecues.value.forEach((detailPr, index) => {
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifTgdNb').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifTgdNb').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifTgdEntret').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifTgdEntret').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifTgdSuivi').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifTgdSuivi').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifTgdNbUrge').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifTgdNbUrge').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifBarNb').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifBarNb').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifBarEntret').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifBarEntret').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifBarSuivi').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifBarSuivi').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifBarNbUrge').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifBarNbUrge').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleSais').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleSais').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleVict').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleVict').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleEntret').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviCpleEntret').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleSais').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleSais').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleVict').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleVict').setValue(null);
            }
            if (this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleEntret').value === 0) {
              this.detailPersonnesRecues.controls[index].get('ccTjVifEvviHcpleEntret').setValue(null);
            }
            this.ccVifVict_AZero = false;
          });    
        }
    });
    this.formulaire.get('ccVifVict').updateValueAndValidity();
  } 


  ngOnDestroy(): void {
    if (this.subFormulaire) {
      this.subFormulaire.unsubscribe();
    }
    if (this.subJuridictions) {
      this.subJuridictions.unsubscribe();
    }
    if (this.subDetailPersonnesRecues) {
      this.subDetailPersonnesRecues.unsubscribe();
    }
    if (this.subCcVifVict) {
      this.subCcVifVict.unsubscribe();
    }
    this.subscriptions.forEach(sub => { sub.unsubscribe(); });
    this.subTab.forEach(sub => { sub.unsubscribe(); });
    this.subTab2.forEach(sub => { sub.unsubscribe(); });
  }

  /** Permet de renseigner libelleJuridiction en fonction de l’identifiantJuridiction passé en paramètre */
  public gestionLibelle(identifiantJuridiction: string): string {
    return this.saisieService.gestionLibelle(identifiantJuridiction, this.modalites);
  }  

  public get formulaire(): UntypedFormGroup {
    return this.formulaireService.getRootForm().get('personnesRecues') as UntypedFormGroup;
  }

  get juridictions() {
    return this.formulaireService.getRootForm().get('dg').get('juridictions') as UntypedFormArray;
  }

  get detailPersonnesRecues() {
    return this.rootForm.get('personnesRecues').get('detailPersonnesRecues') as UntypedFormArray;
  }

  get ccDispoPartAutr(): string {
    return this.rootForm.get('personnesRecues').get('ccDispoPartAutr').value;
  }

  get ccRestauMesure(): number {
    return this.rootForm.get('personnesRecues').get('ccRestauMesure').value;
  }

  public calculTotalTableauC1(): void {
    //Calcul Total ccRecuNbTot 
    this.saisieService.calculTotal2(this.formulaire, 'ccRecuNbTot', 'ccRecuVictNb', 'ccRecuNvictNb');

    //Calcul Total ccRecuSuiviTot 
    this.saisieService.calculTotal2(this.formulaire, 'ccRecuSuiviTot', 'ccRecuVictSuivi', 'ccRecuNvictSuivi');

    //Calcul Total ccRecuEntretTot 
    this.saisieService.calculTotal2(this.formulaire, 'ccRecuEntretTot', 'ccRecuVictEntret', 'ccRecuNvictEntret');
  }

  public calculTotalTableauC2a(): void {
    //Calcul Total ccVictFemTot 
    this.saisieService.calculTotal3(this.formulaire, 'ccVictFemTot', 'ccVictFemMin', 'ccVictFemMaj', 'ccVictFemSenior');

    //Calcul Total ccVictHomTot 
    this.saisieService.calculTotal3(this.formulaire, 'ccVictHomTot', 'ccVictHomMin', 'ccVictHomMaj', 'ccVictHomSenior');

    //Calcul Total ccVictPpTot 
    this.saisieService.calculTotal2(this.formulaire, 'ccVictPpTot', 'ccVictFemTot', 'ccVictHomTot');
  }

  public calculTotalTableauC2b(): void {
    //Calcul Total ccVictMinTot
    this.saisieService.calculTotal2(this.formulaire, 'ccVictMinTot', 'ccVictFemMin', 'ccVictHomMin');

    //Calcul Total ccVictMajTot
    this.saisieService.calculTotal2(this.formulaire, 'ccVictMajTot', 'ccVictFemMaj', 'ccVictHomMaj');

    //Calcul Total ccVictSeniorTot
    this.saisieService.calculTotal2(this.formulaire, 'ccVictSeniorTot', 'ccVictFemSenior', 'ccVictHomSenior');
  }

  public calculTotalTableauC2(): void {
    //Calcul Total ccVictTot
    this.saisieService.calculTotal3(this.formulaire, 'ccVictTot', 'ccVictFemTot', 'ccVictHomTot', 'ccVictPm');
  }

  public calculTotalTableauC35b(): void {
    //Calcul Total ccRestauMesureTot 
    this.saisieService.calculTotal7(this.formulaire, 'ccRestauMesureTot', 'ccRestauMesureRdv', 'ccRestauMesureRcv', 'ccRestauMesureMr', 'ccRestauMesureCr', 'ccRestauMesureCercle', 'ccRestauMesureCsr', 'ccRestauMesureCar');
  }

  private calculAutoTotauxC3(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
  // Calcul des totaux c31a, c31b, c31c, c31d, c32 
      this.subTab.push(this.detailPersonnesRecues.controls[index].get(varBoucle).valueChanges.pipe(debounceTime(100)).subscribe(valeur2 => {
            tabBoucle.splice(index,1,valeur2);
            //console.log(tabBoucle);
            let sum = tabBoucle.reduce((a,b)=>a+b,0);
            //console.log(sum);
            this.formulaire.get(totBoucle).setValue(sum);
      }));
      this.detailPersonnesRecues.controls[index].get(varBoucle).updateValueAndValidity();         
      this.formulaire.get(totBoucle).updateValueAndValidity(); 
  }
 
}